import React from "react";
import './Footer.scss'
import { useTranslation } from "react-i18next";
import { setHeaderLoadType } from "../../slices/vehicleSlice";
import { useSelector } from "react-redux";
import { Grid, Box, useMediaQuery } from "@mui/material";
import privacyIcon from "../../images/svg/privacy-icon.svg";

const Footer = () => {
    const getYear = new Date().getFullYear();
    const { t } = useTranslation();
    const headerLoadType = useSelector(setHeaderLoadType);
    const isMobile = useMediaQuery('(max-width: 768px)');

    return (
        <footer>
            <div className={'footer-main'}>
                {headerLoadType != null ? (
                    <div className="footer-jdpa">
                        <div className="footer-jdpa-container">
                            <Box sx={{ flexGrow: 1, overflowX: isMobile ? 'auto' : 'unset' }}>
                                <Grid
                                    container
                                    spacing={2}
                                    direction={isMobile ? "column" : "row"}
                                    wrap={isMobile ? "nowrap" : "wrap"}
                                    alignItems="flex-start"
                                >
                                    <Grid item xs={isMobile ? 6 : 4} sx={isMobile ? { minWidth: 200 } : {}}>
                                        <div className="logo" />
                                        <div className="logo-quote">
                                            <span>Real insights from real owners</span>
                                        </div>
                                        <div>
                                            <a target="_blank" className="logo-facebook" href={"https://www.facebook.com/jdpower/"}></a>
                                            <a target="_blank" className="logo-twitter" href={"https://twitter.com/JDPower"}></a>
                                            <a target="_blank" className="logo-youtube" href={"https://www.youtube.com/user/jdpowercorporate"}></a>
                                            <a target="_blank" className="logo-linkedin" href={"https://www.linkedin.com/company/j-d--power-and-associates"}></a>
                                        </div>
                                        <div className="footer-copyright">
                                            <span>© {getYear} J. D. Power. All rights reserved.</span>
                                        </div>
                                    </Grid>
                                    <Grid item xs={isMobile ? 6 : 2} sx={isMobile ? { minWidth: 200 } : {}}>
                                        <div><h3>Research &amp; Shopping</h3></div>
                                        <a href={"https://www.jdpower.com/cars-for-sale"}>Cars for Sale</a>
                                        <a href={"https://www.jdpower.com/cars/vin-lookup-and-decoder"}>Free VIN Lookup</a>
                                        <a href={"https://www.jdpower.com/evs/ev-charging-stations-near-me"}>EV Charging Stations Near Me</a>
                                        <a href={"https://www.jdpower.com/cars-for-sale?isNew=false&isElectric=true"}>Electric Cars for Sale</a>
                                        <a href={"https://www.jdpower.com/sell-my-car-2"}>Sell My Car</a>
                                        <a href={"https://www.jdpower.com/cars"}>Used Car Values</a>
                                        <a href={"https://www.jdpower.com/trade-in-value"}>Trade-In Values</a>
                                        <a href={"https://www.jdpower.com/cars/body-styles"}>Types of Cars</a>
                                        <a href={"https://www.jdpower.com/quotes"}>New Car Deals</a>
                                        <a href={"https://www.jdpower.com/cars/shopping-guides"}>Car Shopping Guides</a>
                                    </Grid>
                                    <Grid item xs={isMobile ? 6 : 2} sx={isMobile ? { minWidth: 200 } : {}}>
                                        <div><h3>Company</h3></div>
                                        <a href={"https://www.jdpower.com/business/about-us"}>About Us</a>
                                        <a href={"https://www.jdpower.com/advertise"}>Advertise</a>
                                        <a href={"https://www.jdpower.com/cars/newsletter"}>Subscribe</a>
                                        <a href={"https://www.jdpower.com/business/careers"}>Careers</a>
                                    </Grid>
                                    <Grid item xs={isMobile ? 6 : 2} sx={isMobile ? { minWidth: 200 } : {}}>
                                        <div><h3>Legal</h3></div>
                                        <a href={"https://www.jdpower.com/terms-of-use"}>Terms of Use</a>
                                        <a href={"https://www.jdpower.com/privacy"}>Privacy Policy</a>
                                        <a href={"https://www.jdpower.com/privacy/dsar"}>Your Privacy Choices <img src={privacyIcon}/></a>
                                    </Grid>
                                    <Grid item xs={isMobile ? 6 : 2} sx={isMobile ? { minWidth: 200 } : {}}>
                                        <div><h3>Help &amp; Media</h3></div>
                                        <a href={"https://www.jdpower.com/business"}>Business Products</a>
                                        <a href={"https://www.jdpower.com/contact-us"}>Contact Us</a>
                                        <a href={"https://www.jdpower.com/accessibility"}>Accessibility</a>
                                    </Grid>
                                </Grid>
                            </Box>
                        </div>
                    </div>
                ) : (
                    <div className={'footer-default'}>
                        <div className={'footer-default-container'}>
                            <div className="footer">
                                <div className="footer-container">
                                    <div className="logo" />
                                    <div className="copyright">
                                        <span data-testid='copyright'>&#169; {getYear} </span>{t("footer.copyright")}
                                    </div>
                                    <div className="disclaimer-content">
                                        <div className="footerDisclaimerLinks">
                                            <ul>
                                                <li>
                                                    <p>
                                                        <a href={t('footer.viewPrivacyPolicyLinkUrl')} target="_blank">{t('footer.viewPrivacyPolicy')}</a>
                                                    </p>
                                                </li>
                                                <li>|</li>
                                                <li>
                                                    <p>
                                                        <a href={t('footer.viewDisclaimerLinkUrl')} target="_blank">{t('footer.viewDisclaimer')}</a>
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </footer>
    );
};

export default Footer;